import { HugeiconsIcon } from "@hugeicons/react";
import { InformationCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Card } from "shared/components/Card";
import { Loader } from "shared/components/Loader";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";

const HELP_TEXT =
  "Showing requests that were automatically declined because the lead’s answers didn’t meet one or more of your pre-screening criteria.";

export const PrescreeningFailuresCard = ({
  count,
  isLoading,
  onClick
}: {
  count: number | undefined;
  isLoading: boolean;
  onClick: () => void;
}) => (
  <Card onClick={onClick} className="space-y-2 p-6">
    <div className="flex items-center gap-2">
      <p className="text-sm font-medium text-content-1000">
        Pre-screening criteria failures
      </p>
      <Tooltip placement="top">
        <TooltipTrigger asChild>
          <span
            aria-label="More information"
            className="inline-flex cursor-pointer text-content-300"
            onClick={(e) => e.stopPropagation()}
          >
            <HugeiconsIcon icon={InformationCircleIcon} size={16} />
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-[332px] rounded-lg border border-alpha-40 bg-alpha-800 p-4 text-sm text-content-1000-inverted shadow-xl">
          {HELP_TEXT}
        </TooltipContent>
      </Tooltip>
    </div>
    {isLoading ? (
      <Loader size={24} />
    ) : (
      <p className="text-2xl font-bold text-content-1000">{count ?? "-"}</p>
    )}
  </Card>
);
